import axios from "axios"
import Vue from "vue"
import router from "@/router"
import store from "@/store"
import * as types from "./store/modules/general/mutation_types"

// 不拦截错误的请求，由上层调用拦截
const error_endpoint_blacklist = ["api/v1/order/record/finish"]
const token_not_necessarlist =["/login","/gen_captcha","/smslogin","/conference","/confinform",'/confnotice',
                               "/confguestintro",'/confsite','/confaffairs','/confplace','/hotel','/schedule',
                               '/conference/current',"smscode"]

axios.defaults.timeout = 30000

axios.interceptors.request.use(
  (config) => {
    store.commit("general/" + types.LOADING_START)

    let token = store.getters["auth/token"] || null
    let authorized = token && token.checkValid()
    if (authorized) {
      config.headers.common["Authorization"] = "Bearer " + token.access_token
      return config
    }else{
      let flag = true
      for (const endpoint of token_not_necessarlist) {
        // 标记了的就不提示了，让调用方处理
        if (config.url.endsWith(endpoint)) {
          flag = false
        }
      }
      if (flag){
        // Vue.prototype.$message("无登录信息")
        const CancelToken = axios.CancelToken;
        return {
          ...config,
          cancelToken: new CancelToken((cancel) => cancel('请求需要登陆访问的资源时无登录信息'))
        };
      }
        return config
    }

    
  },
  (error) => {
    store.commit("general/" + types.LOADING_STOP)
    alert(error)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (data) => {
    store.commit("general/" + types.LOADING_STOP)

    return data
  },
  (error) => {
    store.commit("general/" + types.LOADING_STOP)
    if(error.response){
      for (const error_endpoint of error_endpoint_blacklist) {
        // 标记了的就不提示了，让调用方处理
        if (error.response.config.url.endsWith(error_endpoint)) {
          return Promise.reject(error)
        }
      }
      if (
        error.response &&
        error.response.status > 400
      ) {
        let error_data = error.response.data
        if (
          error.request.responseType === "arraybuffer" &&
          error.response.data instanceof ArrayBuffer
        ) {
          error_data = JSON.parse(Buffer.from(error_data).toString("utf8"))
        }
  
        // console.log(error_data)      
        let msg = error_data.msg || error_data.error
        if(error_data.errors){
          // schema error msg
          msg = JSON.stringify(error_data.errors)
        }
  
        if (
          msg &&
          (msg === "Bad credentials" )
        ) {
          router.push({ name: "SignIn" })
        } 
        else if(error.response.config.url.endsWith('auth/login')){
          //因为登陆的错误处理已经在调用中弄处理，就不走下面的弹窗错误提醒逻辑
        }
        else {
          // alert("后台服务器错误:" + msg + ",  错误码:" + error.response.status)
          // Vue.prototype.$dialog.error({
          //   title: "错误码：" + error.response.status,
          //   text: "错误信息：" + msg,
          // })        
          Vue.prototype.$message("错误信息：" + msg)
        }
        return Promise.reject(error)
      } else {
        // error anyway
        return Promise.reject(error)
      }
    }else{
      return Promise.resolve(error)
    }
    
  }
)

const Plugin = {};

Plugin.install = function (Vue) {
  Vue.axios = axios;
  window.axios = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios;
      },
    },
    $axios: {
      get() {
        return axios;
      },
    },
  });
};

Vue.use(Plugin);

export default axios
